export const alertDescriptions = {
    analytics: 'Receive an email for profile statistic updates.',
    issuanceMonitor:
        "Receive an email when selected manager's transactions are published or updated on Issuance Monitor.",
    arrangersPipeline: "Receive an email when selected manager's transactions are published on Arranger Pipeline.",
    bwic: "Receive email notifications once manager's securities are on a BWIC or Post-BWIC color was added.",
    outOfRi:
        "Receive email notifications 3/2/1 month(s), and 1 day before the date when manager’s deals exit the Reinvestment Period.",
    outOfNc:
        "Receive email notifications 3/2/1 month(s), and 1 day before the date when manager’s deals exit the Non-Call Period.",
    dealerInventory:
        "Receive email notifications once manager's securities are added/updated/marked as traded on the Dealer Inventory page.",
};
